import { t } from '@trimble/i18n';
import { Component, Show } from 'solid-js';

export type VolumetricMeasurementPanelAction = 'compute' | 'save';

interface VolumetricMeasurementPanelActionsProps {
  disabled: boolean;
  action: VolumetricMeasurementPanelAction;
  onSubmit(): void;
  onCancel(): void;
  /** Tooltip for the submit button (e.g. when disabled due to Connect permission error). */
  submitButtonTooltip?: string;
}

const SUBMIT_BUTTON_LABEL_KEYS: Record<
  VolumetricMeasurementPanelAction,
  string
> = {
  compute: 'measurements.compute',
  save: 'general.save',
};

function getSubmitButtonLabel(
  action: VolumetricMeasurementPanelAction
): string {
  return t(SUBMIT_BUTTON_LABEL_KEYS[action]);
}

export const VolumetricMeasurementPanelActions: Component<
  VolumetricMeasurementPanelActionsProps
> = (props) => {
  return (
    <>
      <section>
        <div class="flex flex-wrap justify-end gap-2 border-t border-solid border-[var(--modus-wc-color-base-200)] py-3 px-4">
          <modus-wc-button
            data-testid="volumetric-measurement-panel-cancel-button"
            onClick={() => props.onCancel()}
            aria-label={t('general.cancel')}
            color="tertiary"
            shape="rectangle"
            size="md"
            type="button"
            variant="borderless"
          >
            {t('general.cancel')}
          </modus-wc-button>
          <modus-wc-tooltip
            content={props.submitButtonTooltip ?? ''}
            position="top"
            disabled={!(props.submitButtonTooltip && props.disabled)}
          >
            {/* Two separate Shows, because updating the action doesn't change it in Modus*/}
            <Show when={props.action === 'compute'}>
              <modus-wc-button
                data-testid="volumetric-measurement-panel-submit-button"
                // @ts-expect-error The modus types do not support the bool:disabled syntax. It's required to avoid adding the attribute when the value is false.
                bool:disabled={props.disabled ?? true}
                on:buttonClick={() => props.onSubmit()}
                aria-label={getSubmitButtonLabel('compute')}
                color="primary"
                shape="rectangle"
                size="md"
                type="button"
                variant="filled"
              >
                {getSubmitButtonLabel('compute')}
              </modus-wc-button>
            </Show>
            <Show when={props.action === 'save'}>
              <modus-wc-button
                data-testid="volumetric-measurement-panel-submit-button"
                // @ts-expect-error The modus types do not support the bool:disabled syntax. It's required to avoid adding the attribute when the value is false.
                bool:disabled={props.disabled ?? true}
                on:buttonClick={() => props.onSubmit()}
                aria-label={getSubmitButtonLabel('save')}
                color="primary"
                shape="rectangle"
                size="md"
                type="button"
                variant="filled"
              >
                {getSubmitButtonLabel('save')}
              </modus-wc-button>
            </Show>
          </modus-wc-tooltip>
        </div>
      </section>
    </>
  );
};
